import Amplitude from "@/helpers/amplitude";
export default defineNuxtPlugin((nuxtApp) => {
  Amplitude.init();
});
